import React from 'react';
import { FadeIn } from './FadeIn';
export function ClosingContrast() {
  return <section className="py-16 sm:py-24 px-4 bg-pump-dark" data-id="element-37">
      <div className="max-w-5xl mx-auto" data-id="element-38">
        <FadeIn data-id="element-39">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-40">
            Una última cosa antes de que decidas.
          </h2>
          <p className="text-xl text-center text-gray-300 mb-12" data-id="element-41">
            La próxima semana vas a estar en alguno de estos dos lugares.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-16" data-id="element-42">
          <FadeIn delay={0.1} data-id="element-43">
            <div className="bg-pump-surface border border-red-500/20 p-8 rounded-2xl h-full" data-id="element-44">
              <div className="text-red-400 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-45">
                El primer lugar
              </div>
              <p className="text-gray-300 leading-relaxed" data-id="element-46">
                Entrás a la sala con la misma rutina de siempre. Decís los
                mismos cues. La clase sale "bien". Tus alumnos se van sin decir
                nada especial. Y vos salís del gimnasio con la sensación de que
                algo falta, que podría haber sido mejor, que estás estancado. La
                semana siguiente es exactamente igual.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-47">
            <div className="bg-pump-gold/5 border border-pump-gold/30 p-8 rounded-2xl h-full shadow-[0_0_30px_rgba(245,200,66,0.05)]" data-id="element-48">
              <div className="text-pump-gold font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-49">
                El segundo lugar
              </div>
              <p className="text-white leading-relaxed font-medium" data-id="element-50">
                Entrás a la sala con el sistema. Sabés exactamente qué decir en
                cada track, cómo manejar el cuerpo en el escenario y cómo cerrar
                la clase de una forma que los alumnos van a recordar. Después de
                la clase, tres personas te buscan para charlar. El miércoles
                siguiente tu sala tiene dos alumnos nuevos que vinieron porque
                alguien los mandó.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-51">
          <div className="text-center" data-id="element-52">
            <p className="text-xl sm:text-2xl text-gray-300 mb-6" data-id="element-53">
              La diferencia entre esos dos lugares no es el talento. No es la
              experiencia. No es la energía.
            </p>
            <p className="text-4xl sm:text-6xl font-display font-black text-white uppercase tracking-tight" data-id="element-54">
              Es el sistema. <br data-id="element-55" />
              <span className="text-pump-gold" data-id="element-56">Y el sistema está acá.</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}